export class ProfessionalLearningDTO {
    PLAId: string;
    Provider: string;
    ActivityDetails: string;
    TopicDescription: string;
    ReflectivePractice: string;
    ImagePath: string;
    ImageBase64:string
    EvidenceDescription: string;
    CPD: string;
    StartDate: string;
    StartTime: string;
    Start: string;
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Models/ProfessionalLearning.model.ts